class MenuManager {
	private readonly burger: NodeListOf<Element>;
	private readonly menu: NodeListOf<Element>;
	private readonly close: NodeListOf<Element>;
	private readonly backdrop: NodeListOf<Element>;

	private readonly searchButton: NodeListOf<Element>;
	private readonly searchContainer: NodeListOf<Element>;
	private readonly searchBackdrop: NodeListOf<Element>;
	private searchOpened: boolean = false;

	public constructor() {
		this.burger = document.querySelectorAll('.navbar-burger');
		this.menu = document.querySelectorAll('.navbar-menu');
		this.close = document.querySelectorAll('.navbar-close');
		this.backdrop = document.querySelectorAll('.navbar-backdrop');

		this.searchButton = document.querySelectorAll('.search-button');
		this.searchContainer = document.querySelectorAll('.search-container');
		this.searchBackdrop = document.querySelectorAll('.search-backdrop');

		if (this.burger.length && this.menu.length) {
			for (let i = 0; i < this.burger.length; i++) {
				this.burger[i].addEventListener('click', this.openMenu.bind(this));
			}
		}

		if (this.close.length) {
			for (let i = 0; i < this.close.length; i++) {
				this.close[i].addEventListener('click', this.closeMenu.bind(this));
			}
		}

		if (this.backdrop.length) {
			for (let i = 0; i < this.backdrop.length; i++) {
				this.backdrop[i].addEventListener('click', this.closeMenu.bind(this));
			}
		}

		if (this.searchButton.length && this.searchContainer.length) {
			for (let i = 0; i < this.searchButton.length; i++) {
				this.searchButton[i].addEventListener('click', this.toggleSearch.bind(this));
			}
		}

		if (this.searchBackdrop.length) {
			for (let i = 0; i < this.searchBackdrop.length; i++) {
				this.searchBackdrop[i].addEventListener('click', this.closeSearch.bind(this));
			}
		}
	}

	private addClassToAll<E extends Element = Element>(el: NodeListOf<E>, className: string) {
		if (el.length) {
			for (let i = 0; i < el.length; i++) {
				el[i].classList.add(className);
			}
		}
	};

	private removeClassFromAll<E extends Element = Element>(el: NodeListOf<E>, className: string) {
		if (el.length) {
			for (let i = 0; i < el.length; i++) {
				el[i].classList.remove(className);
			}
		}
	};

	private openMenu() {
		this.closeSearch();

		for (let i = 0; i < this.menu.length; i++) {
			this.menu[i].classList.remove('hidden');
			this.removeClassFromAll(this.close, 'hidden');
			this.addClassToAll(this.burger, 'hidden');
		}
	};

	private closeMenu() {
		for (let i = 0; i < this.menu.length; i++) {
			this.menu[i].classList.add('hidden');
			this.removeClassFromAll(this.burger, 'hidden');
			this.addClassToAll(this.close, 'hidden');
		}
	};

	private toggleSearch() {
		if (this.searchOpened) {
			this.closeSearch();
			return;
		}

		this.closeMenu();

		for (let i = 0; i < this.searchContainer.length; i++) {
			this.searchContainer[i].classList.remove('hidden');
		}

		this.searchOpened = true;
	};

	private closeSearch() {
		for (let i = 0; i < this.searchContainer.length; i++) {
			this.searchContainer[i].classList.add('hidden');
		}

		this.searchOpened = false;
	};
}

document.addEventListener('DOMContentLoaded', () => {
	new MenuManager();
});
